import React from 'react'

import { CustomizableComponent } from '@contracts/components/customizableComponent'

import { useThemeSettings } from '@hooks/useThemeSettings'

import * as styles from './SocialMedia.module.scss'

import Facebook from '@icons/facebook.svg'
import Instagram from '@icons/instagram.svg'
import Linkedin from '@icons/linkedin.svg'
import Twitter from '@icons/twitter.svg'
import Youtube from '@icons/youtube.svg'

interface Props extends CustomizableComponent {}

const SocialMedia: React.FunctionComponent<Props> = (props) => {
	const themeSettings = useThemeSettings()

	// Turn the socialMedia object into an array
	// of objects with the key as the name of the
	// social media platform and the value as the
	// link to the social media platform
	const platforms = Object.keys(themeSettings.socialMedia).map((key) => ({
		// Capitalize the first letter of the platform name
		name: key,
		link: themeSettings.socialMedia[key as keyof typeof themeSettings.socialMedia],
	}))

	const classNames = [styles.socialMedia]

	if (props.className) {
		classNames.push(props.className)
	}

	return (
		<ul className={classNames.join(' ')}>
			{platforms.map((platform) => {
				let icon: JSX.Element | null = null

				switch (platform.name) {
					case 'facebook':
						icon = <Facebook className={styles.icon} />
						break
					case 'instagram':
						icon = <Instagram className={styles.icon} />
						break
					case 'linkedin':
						icon = <Linkedin className={styles.icon} />
						break
					case 'twitter':
						icon = <Twitter className={styles.icon} />
						break
					case 'youtube':
						icon = <Youtube className={styles.icon} />
						break
					default:
						icon = null
						break
				}

				if (platform.link !== '' && icon) {
					return (
						<li className={styles.platform} key={platform.name}>
							<a
								href={platform.link}
								target="_blank"
								rel="noopener noreferrer"
								title={platform.name}
								aria-label={platform.name}
							>
								{icon}
							</a>
						</li>
					)
				}
			})}
		</ul>
	)
}

export default SocialMedia
